module.exports = __webpack_public_path__ + "assets/scissors.6619831c.svg";